import { Box, ListItemSelect } from "@wix/design-system";
import React, { useContext, useMemo } from "react";
import { RicosContext } from "./../../../ricos-context";
import { PREDEFINED_SPACING_OPTION } from "../../data-hooks";
const PREDEFINED_LINE_HEIGHTS = [
  { text: "1", commandKey: "1" },
  { text: "1.5", commandKey: "1.5" },
  { text: "2", commandKey: "2" },
  { text: "2.5", commandKey: "2.5" },
  { text: "3", commandKey: "3" }
];
const SpacingSelector = ({
  lineSpacing,
  initialLineSpacing,
  onSelectSpacing
}) => {
  const { isMobile } = useContext(RicosContext);
  const options = useMemo(() => {
    const current = lineSpacing["line-height"];
    const isCurrentInOptions = PREDEFINED_LINE_HEIGHTS.some(
      (lineHeight) => lineHeight.text === current
    );
    return isCurrentInOptions ? PREDEFINED_LINE_HEIGHTS : [...PREDEFINED_LINE_HEIGHTS, { text: current, commandKey: current }].sort(
      (a, b) => Number(a.commandKey) - Number(b.commandKey)
    );
  }, [lineSpacing["line-height"]]);
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      direction: "vertical",
      gap: "SP1",
      marginTop: "SP2",
      marginBottom: "SP2",
      width: isMobile ? "100%" : "fit-content",
      minWidth: "152px"
    },
    options.map(({ text, commandKey }) => /* @__PURE__ */ React.createElement(
      ListItemSelect,
      {
        dataHook: PREDEFINED_SPACING_OPTION,
        key: commandKey,
        title: text,
        selected: initialLineSpacing["line-height"] === commandKey,
        onClick: () => {
          onSelectSpacing({ ...lineSpacing, "line-height": commandKey });
        },
        ellipsis: true,
        size: isMobile ? "medium" : "small"
      }
    ))
  );
};
export {
  SpacingSelector
};
//# sourceMappingURL=spacing-selector.js.map
